import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const AddNotesForMachineTransaction = (props) => {
  const { onBack, onNext, selectedNotes, setSelectedNotes } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Any notes to add?</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>This is optional - only add notes if you feel like it's important</p>
          <TextField
            id="add-notes"
            label="Notes"
            onChange={(event) => {
                setSelectedNotes(event.target.value);
            }}
            sx={{ width: '300px' }}
            value={selectedNotes ?? ''}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton)}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default AddNotesForMachineTransaction;
